<template>
    <AuthShell
        title="Credenciais internas"
        description="Utiliza o teu email e password para continuares a autenticação na plataforma interna."
    >
        <template #actions>
            <button class="btn btn-primary" @click="handleCredentialLogin">
                <span class="btn-icon">→</span>
                <span>Entrar com email e password</span>
            </button>
        </template>

        <template #footer>
            <router-link to="/" class="text-link">Voltar ao login principal</router-link>
        </template>
    </AuthShell>
</template>

<script>
import AuthShell from "@/components/auth/AuthShell.vue";
import { loginWithCredentials } from "@/services/keycloakAuth";

export default {
    name: "CredView",

    components: {
        AuthShell,
    },

    methods: {
        handleCredentialLogin() {
            return loginWithCredentials();
        },
    },
};
</script>

<style scoped>
.text-link {
    display: inline-flex;
    justify-content: center;
    width: 100%;
    margin-top: 14px;
    color: var(--primary);
    font-size: 13px;
    font-weight: 700;
    text-decoration: none;
}

.text-link:hover {
    text-decoration: underline;
}
</style>
